import { useUtilityStates } from "../useStates";

import { SliderContainerType } from "../SliderContainer";
import Title from "../../LoanTermDeviation/Title";

import { formatAndMaskMobile } from "../utils";

export default function LeadSuccess(props: SliderContainerType) {
  const { close } = props;

  const { customerData } = useUtilityStates((state) => state);

  return (
    <div className="p-6 sm:p-10 relative">
      <Title
        title=""
        close={close}
      />

      <div className="flex justify-center mt-8 sm:mt-10">
        <div className="max-w-md text-center">
          <div className="flex justify-center">
            <img
              alt="success"
              className="w-36 h-40 sm:w-44 sm:h-48"
              src="/lunch-success.png"
            />
          </div>
          <div className="text-[#373737] text-xl sm:text-2xl font-medium mt-8 sm:mt-12">
            Lead created successfully!
          </div>
          <div className="text-[#4C4C4D] text-base sm:text-lg font-medium mt-4 sm:mt-5">
            The Session link has been sent to the user on{" "}
            {formatAndMaskMobile(customerData?.mobile)}
          </div>
          <div className="text-[#8D8D8E] text-xs sm:text-sm font-medium mt-3">
            The user will need to finish the journey on the link to get the
            disbursal.
          </div>
        </div>
      </div>
    </div>
  );
}
